import React, { useState, useEffect } from 'react';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import clsx from 'clsx';
import apiService from '../../../services/apiService';
import { ServiceDialog, ConfirmButton, CancelButton } from '../../../styling/Styles';

// This function extracts user's id from a given url
const extractProjectId = (url) => {
  const comps = url.split('/');
  let indexFind = -1;

  comps.forEach((comp, index) => {
    if(comp === 'project' && index !== comp.length-1){
      indexFind = index + 1;
    }
  });

  return indexFind !== -1 ? comps[indexFind] : indexFind;
};

// This component is used to render the pop up with user's pending invitations
export default function Message({ open, setOpen, setUpdateData, dispatch }) {
  const [messages, setMessages] = useState([]);
  const [userId, setUserId] = useState(-1);
  const [updateInvitations, setUpdateInvitations] = useState(false);

  // This useEffect is used to ask from server all user's messages.
  useEffect(() => {
    apiService
      .getUserField('messages')
      .then((response) => response.data)
      .then((messagesId) =>
        Promise.all(messagesId.map((messageId) => apiService.getMessage(messageId)))
      )
      .then((responses) => responses.map((response) => response.data))
      .then((data) => setMessages(data))
      .catch((error) => {
        if (error.message === 'authentication failed') dispatch({ type: 'LOGOUT' });
      });

    const user = JSON.parse(localStorage.getItem('user'));

    apiService
      .getUserWithParam({ name: user.login })
      .then((response) => setUserId(response.data._id))
      .catch((error) => {
        if (error.message === 'authentication failed') dispatch({ type: 'LOGOUT' });
      });

    setUpdateInvitations(false);
  }, [open, updateInvitations]);

  // This function is used to close messageDialog pop up
  const handleClose = () => {
    setOpen(false);
    if (setUpdateData !== undefined) {
      setUpdateData(true);
    }
  };

  return (
    <ServiceDialog
      open={open}
      keepMounted
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <div style={{ height: '100%' }}>
        <div className={clsx('titlePopUp', 'paddingTitle')}>
          Messages
          <div
            onClick={handleClose}
            className="gjs-mdl-btn-close"
            style={{ fontSize: '2.2rem' }}
            data-close-modal=""
            aria-hidden="true"
          >
            ⨯
          </div>
        </div>
        <div
          className={clsx('paddingTitle')}
          style={{ height: '90%', overflowY: 'auto', maxHeight: '650px' }}
        >
          <div className={clsx('spacingTopDiv2', 'spacingLeftDiv', 'spacingRightDiv')}>
            <ShowMessage
              messages={messages}
              userId={userId}
              setUpdateInvitations={setUpdateInvitations}
            />
          </div>
        </div>
      </div>
    </ServiceDialog>
  );
}

// This component is used to render the available actions for a user's message.
const MessageActions = ({ message, userId, setUpdateInvitations, indexMessage, dispatch }) => {
  // This function  deletes a message from database.
  function deleteUsersMessage() {
    const projectId = extractProjectId(message.action.config.url);

    if (projectId !== -1) {
      apiService
        .deleteUsersMessage({ userId, messageId: message._id, projectId })
        .then((response) => response)
        .catch((error) => {throw(error)});
    }
  }

  // This function is runned when user clicks accept and deletes a message from database and connect user with project.
  function handleAccept() {

    deleteUsersMessage();
    apiService
      .doAction(message.action.config)
      .catch((error) => {
        if (error.message === 'authentication failed') dispatch({ type: 'LOGOUT' });
      });

    setUpdateInvitations(true);
  }

  /*
   *   This function is runned when user clicks decline button.It deletes message from database and update the component to not render
   *   current message again.
   */
  function handleDecline() {
    deleteUsersMessage();
    setUpdateInvitations(true);
  }

  return (
    <div style={{ marginLeft: '1vw' }}>
      <CancelButton id={`declineButton${indexMessage}`} onClick={() => {handleDecline()}}>
        Decline
      </CancelButton>
      <ConfirmButton
        id={`acceptButton${indexMessage}`}
        style={{ marginLeft: '1vw' }}
        onClick={() => {handleAccept()}}
      >
        Accept
      </ConfirmButton>
    </div>
  );
};

// This component maps all user's messages
const ShowMessage = ({ messages, userId, setUpdateInvitations, dispatch }) => {
  const messagesArray = messages
    .filter((message) => message._id)
    .map((message, indexMessage) => (
      <ListItem key={message._id}>
        {message.inviterLogin !== undefined && (
          <ListItemText
            id={`invitation${indexMessage}`}
            primary={`${message.inviterLogin} has invited you to join project ${message.projectName}`}
          />
        )}
        {message.messageSubject !== undefined && (
          <ListItemText primary={message.messageSubject} secondary={message.messageText} />
        )}
        <MessageActions
          message={message}
          userId={userId}
          setUpdateInvitations={setUpdateInvitations}
          indexMessage={indexMessage}
          dispatch={dispatch}
        />
      </ListItem>
    ));
  return messagesArray.length > 0 ? <List>{messagesArray}</List> : 'There are no messages available for this user';
};



export { ShowMessage, MessageActions, extractProjectId };
